// local
import Api from '.';

export function list() {
    return Api.get('/account');
}

export function create(data) {
    return Api.post('/account', data);
}

export function update(id, data) {
    return Api.put(`/account/${id}`, data);
}

export default { list, create, update };
